import {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {MenuTestPage} from '../pages/MenuTestPage'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {DisableSidebar} from '../../_metronic/layout/core'
import {WithChildren} from '../../_metronic/helpers'
import BuilderPageWrapper from '../pages/layout-builder/BuilderPageWrapper'
import {useAuth} from '../modules/auth'
import HomePage from '../modules/apps/home/HomePage'
import { Home } from '../modules/apps/home/Home'
import PersonalPage from '../modules/apps/personal-publication/PersonalPage'
import { PersonalPublication } from '../modules/apps/personal-publication/PersonalPublication'
import AboutPage from '../modules/apps/aboutus/AboutPage'
import { AboutUs } from '../modules/apps/aboutus/AboutUs'
import GuideRoute from '../modules/apps/personal-publication/GuideRoute'
import KnowledgeRoute from '../modules/apps/personal-publication/KnowledgeRoute'
import { MultipleKnowledge } from '../modules/apps/personal-publication/MultipleKnowledgePage'
import MultiKnowledgeRoute from '../modules/apps/personal-publication/MultiKnowledgeRoute'

const PrivateRoutes = () => {
  const ProfilePage = lazy(() => import('../modules/profile/ProfilePage'))
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const WidgetsPage = lazy(() => import('../modules/widgets/WidgetsPage'))
  const ChatPage = lazy(() => import('../modules/apps/chat/ChatPage'))
  const DevPage = lazy(() => import('../modules/apps/dev/DevPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))
  const {currentUser} = useAuth()

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/home' />} />
        {/* Pages */}
        <Route path='home' element={<Home />} />
        {currentUser && <Route path='personal_publication' element={<PersonalPublication />} />}
        <Route path='home' element={<AboutUs />} />
        {/* <Route path='knowledge_management' element={<KnowledgeManagement />} /> */}
        <Route path='knowledge_management' element={<KnowledgeRoute />} />
        <Route path='multi_knowledge' element={<MultipleKnowledge />} />
        <Route path='guideline' element={<GuideRoute/>} />
        <Route path='menu-test' element={<MenuTestPage />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/widgets/*'
          element={
            <SuspensedView>
              <WidgetsPage />
            </SuspensedView>
          }
        />
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/chat/*'
          element={
            <SuspensedView>
              <ChatPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/devs/*'
          element={
            <SuspensedView>
              <DevPage />
            </SuspensedView>
          }
        />
        <Route
          path='guideline/*'
          element={
            <SuspensedView>
              <GuideRoute />
            </SuspensedView>
          }
        />
        <Route
          path='knowledge_management/*'
          element={
            <SuspensedView>
              {/*<KnowledgeManagement />*/}
              <KnowledgeRoute />
            </SuspensedView>
          }
        />
        
        <Route
          path='multi_knowledge/*'
          element={
            <SuspensedView>
              {/*<MultipleKnowledge />*/}
              <MultiKnowledgeRoute/>
            </SuspensedView>
          }
        />
        <Route
          path='home/*'
          element={
            <SuspensedView>
              <HomePage />
            </SuspensedView>
          }
        />
        <Route
          path='personal_publication/*'
          element={
            <SuspensedView>
              <PersonalPage />
            </SuspensedView>
          }
        />
        <Route
          path='about_us/*'
          element={
            <SuspensedView>
              <AboutPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--kt-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return (
    <Suspense fallback={<TopBarProgress />}>
      <DisableSidebar>{children}</DisableSidebar>
    </Suspense>
  )
}

export {PrivateRoutes}
